import type { ApiPlugin } from '@srm/core/http';
import { SUPPORT_SHARE_HEADER } from '@srm/screen-sharing/light';

let publishing: string | null = null;

/** Эта вкладка показывает экран поддержке (`shareId` показа) или перестала (`null`). */
export function setPublishingShare(shareId: string | null): void {
    publishing = shareId;
}

/**
 * Заголовок показа ко всем запросам WebAPI из вкладки, которая показывает экран: окно управления сервер применяет только
 * к ним, и работа пользователя в других вкладках не записывается как действия поддержки.
 */
export const supportShareHeaders = (): Record<string, string> =>
    publishing ? { [SUPPORT_SHARE_HEADER]: publishing } : {};

/** Плагин клиента: заголовок показа — и к запросам axios, и к keepalive. */
export const supportShareHeaderPlugin = (): ApiPlugin => ({
    name: 'support-share',
    request: ({ headers }) => {
        Object.assign(headers, supportShareHeaders());
    },
});
